module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAASlJREFUeNpiVJYQFWBgYABheoIPLEDCAIgd6GzxASaGAQKjFg+8xa6eXhIgTK7BhPTjtNjY1FRiwvQZ8eRYDtID0gsyA5caZiEebgUgrYAuceTgwRd8fHxfy2vrgm/fvHn33p3bX0ixdPG8uTs7mhov4FD2AKfF5FhOpKWELSbFchIsJc5iYiwn0VLiLcZnORmWkmYxNsuVVVV5yLAUbDELqVkFZgHIQhBNhqXkl1xnT59+gY1NU4uR4xSEyS1kWMi1FDl4QWIFmRkLd2/fRrTviU5cuCwls4QjLlUTyjJkWE7YYmLzKYmW47eY1MKBBMtxW0xmiUSs5bgtDouKUrl0/vxdcgoHmOVS0tI8IDY2ixmB7WqH0ebtqMW0AKCy+gMoldG70wYQYAAojz4v5SPc/QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/icon-x.png
// module id = 7Gm1
// module chunks = 1